import type { Sd844TemplateSupplierRow } from '@erp/rpc';

/**
 * Filtering rules for the 844 Configuration supplier list. Pure, so the
 * filters are testable without rendering the page.
 */

/**
 * The route segment that addresses the ORG DEFAULT template rather than a
 * supplier — `/ship-and-debit/844-configuration/default`. Never a UUID, so it
 * cannot collide with a company id.
 */
export const DEFAULT_TEMPLATE_ROUTE_ID = 'default';

/** The template a route segment edits: a company id, or `null` for the default. */
export function templateCompanyIdFromRoute(segment: string): string | null {
  return segment === DEFAULT_TEMPLATE_ROUTE_ID ? null : segment;
}

export type DeliveryFilter = 'all' | 'edi' | 'email';

/** Client-side filter: delivery method plus free-text over name and file. */
export function filterSuppliers(
  suppliers: Sd844TemplateSupplierRow[],
  { delivery, search }: { delivery: DeliveryFilter; search: string },
): Sd844TemplateSupplierRow[] {
  const query = search.trim().toLowerCase();
  return suppliers.filter((supplier) => {
    if (delivery !== 'all' && supplier.deliveryMethod !== delivery)
      return false;
    if (!query) return true;
    return (
      supplier.name.toLowerCase().includes(query) ||
      (supplier.template?.originalFilename.toLowerCase().includes(query) ??
        false)
    );
  });
}
